import { SingleSelectDropdown } from "Components/SingleSelectDropdown";
import { Flex, Typography } from "antd";

export const Identity = ({ identity, setIdentity }) => {
  const { Title } = Typography;
  return (
    <Flex vertical justify="flex-start" align="flex-start">
      <Title style={{ fontSize: "18px", fontWeight: "500" }}>I am a</Title>
      <SingleSelectDropdown
        options={[
          { label: "Parent/Guardian", value: "Parent/Guardian" },
          {
            label: "Student",
            value: "Student",
          },
          {
            label: "Counselor",
            value: "Counselor",
          },
        ]}
        placeholder="Select"
        loading={false}
        onChange={(value) => {
          setIdentity(value);
        }}
        value={identity}
      />
    </Flex>
  );
};
